// levels/registry.ts — the ordered list of all 15 levels.
// Real levels replace their stub in the phase that owns them. Phase 1 lands Act I
// (L01–L03); L04–L15 remain placeholders (biometrics → Phase 2, judged → Phase 3/4, …).

import type { Level } from "@/levels/types.ts";
import { L01 } from "@/levels/L01.ts";
import { L02 } from "@/levels/L02.ts";
import { L03 } from "@/levels/L03.ts";
import { L04 } from "@/levels/L04.ts";
import { L05 } from "@/levels/L05.ts";
import { L06 } from "@/levels/L06.ts";
import { L07 } from "@/levels/L07.ts";
import { L08 } from "@/levels/L08.ts";
import { L09 } from "@/levels/L09.ts";
import { L10 } from "@/levels/L10.ts";
import { L11 } from "@/levels/L11.ts";
import { L12 } from "@/levels/L12.ts";
import { L13 } from "@/levels/L13.ts";
import { L14 } from "@/levels/L14.ts";
import { L15 } from "@/levels/L15.ts";

// All fifteen levels, ordered L01…L15 (ids are zero-padded so lexicographic order equals
// numeric order). No stubs remain — Phase 5 lands the last three.
const BUILT: Level[] = [
  L01, L02, L03, L04, L05, L06, L07, L08, L09, L10, L11, L12, L13, L14, L15,
];
export const LEVELS: readonly Level[] = [...BUILT].sort((a, b) => a.id.localeCompare(b.id));
